import { generatePath } from 'react-router-dom';

import { ROUTE_TEMPLATES } from '../constants/routes';
import { IInitKeys } from '../types/shipping';

export const buildPath = (pattern: string, params: Record<string, string | undefined>): string => {
  const cleanedParams = Object.fromEntries(
    Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== '')
      .map(([key, value]) => [key, value?.replace(/^\/+/, '')]),
  );

  return generatePath(pattern, cleanedParams);
};

export const buildClaimStepPath = ({ one_link_id, order_id, key }: IInitKeys, stepName: string): string =>
  one_link_id
    ? buildPath(ROUTE_TEMPLATES.ONE_LINK, { oneLinkId: one_link_id, step: stepName })
    : buildPath(ROUTE_TEMPLATES.SEND, { orderId: order_id || '', key: key || '', step: stepName });
